/** Chave usada no LocalStorageService para o token de acesso salvo por token-verify. */
export const ACCESS_TOKEN_KEY = 'accessToken';

/** Chave usada no LocalStorageService para as escolhas da tela de autopatrocínio (EscolhaAutopatrocinio). */
export const AUTOPATROCINIO_KEY = 'autopatrocinio';

/** Chave usada no LocalStorageService para as escolhas da tela de resgate (EscolhaResgate). */
export const RESGATE_KEY = 'resgate';

export const ACCESS_TOKEN_PORTAL_KEY = 'accessTokenPortal';

export const REQUERIMENTO_ID_KEY = 'requerimentoId';

/** Chave usada no LocalStorageService para alterar a url do resgate - true para ir no fluxoDefinitivo */
export const FLUXO_DEFINITIVO = 'fluxoDefinitivo';
